import React from "react";
import { ExpendableLink } from "./expendable-link";
import {
  LayoutDashboard,
  Building2,
  Contact2,
  Megaphone,
  Mail,
  Settings,
  Layers,
  FileText,
  Newspaper,
  Compass,
  Globe,
  Target,
  ListChecks,
  Lightbulb,
  Blocks,
} from "lucide-react";

interface IProps {
  isEmployee?: boolean;
}

export const ClientMenu: React.FC<IProps> = ({ isEmployee }) => {
  return (
    <>
      <ExpendableLink
        url="/"
        title="Dashboard"
        icon={<LayoutDashboard size={18} />}
      />

      <ExpendableLink
        title="Prospects"
        url="/prospects"
        icon={<Target size={18} />}
      />
      <ExpendableLink
        title="Clients"
        url="/customers"
        icon={<Building2 size={18} />}
      />
      <ExpendableLink
        title="Contacts"
        url="/contacts"
        icon={<Contact2 size={18} />}
      />
      <ExpendableLink
        title="Prospections"
        url="/prospections"
        icon={<Megaphone size={18} />}
      />
      {isEmployee && (
        <ExpendableLink
          title="Tâches"
          url="/customer-tasks"
          icon={<ListChecks size={18} />}
        />
      )}
      {isEmployee && (
        <ExpendableLink
          title="Aide à la vente"
          url="/sales-arguments"
          icon={<Lightbulb size={18} />}
        />
      )}
      <ExpendableLink
        title="Rapports SEO"
        url="/reports"
        icon={<FileText size={18} />}
      />
      <ExpendableLink
        title="Articles"
        url="/articles"
        icon={<Newspaper size={18} />}
      />
      <ExpendableLink
        title="CMS"
        url="/cms"
        icon={<Layers size={18} />}
      />
      {isEmployee && (
        <ExpendableLink
          title="Catégories"
          url="/categories"
          icon={<Blocks size={18} />}
        />
      )}
      <ExpendableLink
        title="Sites générés"
        url="/created-sites"
        icon={<Globe size={18} />}
      />
      <ExpendableLink
        title="Emails"
        url="/mail-messages"
        icon={<Mail size={18} />}
      />
      <ExpendableLink
        title="Ma boite mail"
        url="/my-mailbox"
        icon={<Settings size={18} />}
      />
      <ExpendableLink
        title="Tuto"
        url="/tuto"
        icon={<Compass size={18} />}
      />
    </>
  );
};
